import { useQuery } from "@oysterhr/core"
import { gql } from "@apollo/client"
import { Query } from "@oysterhr/schema"
import { DEPENDENTS_ON_ENGAGEMENT_FRAGMENT } from "../fragments/DependentsOnEngagementFragment"
import { DEPENDENT_ENROLLMENTS_ON_ENROLLMENT_FRAGMENT } from "../fragments/DependentEnrollmentsOnEnrollmentFragment"
import { MONEY_FIELDS } from "~/shared/fragments/MoneyFields"
import { DEPENDENT_ENROLLMENTS_ON_PROVISIONED_ENROLLMENT_FRAGMENT } from "../fragments/DependentProvisionedEnrollmentsOnEnrollmentFragment"

export const TM_BENEFIT_ENROLLMENTS_QUERY_NAME = "BenefitsTeamMemberEnrollments"

export const TMBenefitEnrollmentsQuery = gql`
  ${MONEY_FIELDS}
  ${DEPENDENTS_ON_ENGAGEMENT_FRAGMENT}
  ${DEPENDENT_ENROLLMENTS_ON_ENROLLMENT_FRAGMENT}
  ${DEPENDENT_ENROLLMENTS_ON_PROVISIONED_ENROLLMENT_FRAGMENT}
  query ${TM_BENEFIT_ENROLLMENTS_QUERY_NAME}($engagementId: ID!) {
      engagement(engagementId: $engagementId) {
        id
        state
        ...DependentsOnEngagementFragment
        benefitsEnrollments {
          collection {
            id
            type
            state
            coverageStartDate
            ...DependentEnrollmentsOnEnrollmentFragment
            totalPrice {
              ...MoneyFields
            }
            totalPriceInvoicedCompany {
              ...MoneyFields
            }
            currentPrice {
              tmInvoicedContribution {
                ...MoneyFields
              }
            }
            plan {
              category
              name
              copy
              guideUrl
              externalLink
              logoUrl
              provider {
                name
              }
            }
          }
        }
        benefitsProvisionedEnrollments {
          collection {
            id
            type
            state
            coverageStartDate
            ...DependentEnrollmentsOnProvisionedEnrollmentFragment
            plan {
              category
              name
              copy
              guideUrl
              externalLink
              logoUrl
              provider {
                name
              }
              priceEstimate {
                currencies {
                  ...MoneyFields
                }
              }
            }
          }
        }
      }
  }
`

export function useTeamMemberBenefitEnrollments(engagementId: string) {
  return useQuery<Pick<Query, "engagement">>(TMBenefitEnrollmentsQuery, {
    variables: { engagementId },
    fetchPolicy: "network-only",
  })
}
